import GroupUser from './group-user.png';
import BackLeft from './back-left.png';

export default {
  'group-user': GroupUser,
  'back-left': BackLeft,
};
